//imports
import { HashRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Subscribe from "./pages/Subscribe";
import OtpConfirm from "./pages/OtpConfirm";
import Topups from "./pages/topups/Topups";
import TopupCreate from "./pages/topups/TopupCreate";
import Play from "./pages/play/Play";
import PlayCreate from "./pages/play/PlayCreate";
import ErrorBoundary from "./components/ErrorBoundary";
import Transactions from "./pages/transactions/Transactions";
import Client from "./pages/clients/Client";
import ClientCreate from "./pages/clients/ClientCreate";
import ClientEdit from "./pages/clients/ClientEdit";
import ServiceType from "./pages/serviceType/ServiceType";
import ServiceTypeCreate from "./pages/serviceType/ServiceTypeCreate";
import ServiceTypeEdit from "./pages/serviceType/ServiceTypeEdit";
import SdpService from "./pages/sdpService/SdpService";
import SdpServiceCreate from "./pages/sdpService/SdpServiceCreate";
import SdpServiceEdit from "./pages/sdpService/SdpServiceEdit";
import AppUsers from "./pages/appUsers/AppUsers";
import AppUserCreate from "./pages/appUsers/AppUserCreate";
import AppUserEdit from "./pages/appUsers/AppUserEdit";
import Deposit from "./pages/deposit/Deposit";
import DepositCreate from "./pages/deposit/DepositCreate";
import DepositEdit from "./pages/deposit/DepositEdit";
import Winning from "./pages/winning/Winning";
import WinningCreate from "./pages/winning/WinningCreate";
import WinningEdit from "./pages/winning/WinningEdit";
import InteractiveSms from "./pages/interactiveSms/InteractiveSms";
import SmsMessage from "./pages/smsMessage/SmsMessage";
import DailyUsers from "./pages/dailyUsers/DailyUsers";
import SmsMessageCreate from "./pages/smsMessage/SmsMessageCreate";
import Phonebook from "./pages/phonebook/Phonebook";
import PhonebookCreate from "./pages/phonebook/PhonebookCreate";
import PhonebookEdit from "./pages/phonebook/PhonebookEdit";
import Phonebookupload from "./pages/phonebookupload/Phonebookupload";
import PhonebookuploadCreate from "./pages/phonebookupload/PhonebookuploadCreate";
import PhonebookuploadEdit from "./pages/phonebookupload/PhonebookuploadEdit";
import Bulkbroadcast from "./pages/bulkbroadcast/Bulkbroadcast";
import BulkbroadcastCreate from "./pages/bulkbroadcast/BulkbroadcastCreate";
import BulkbroadcastEdit from "./pages/bulkbroadcast/BulkbroadcastEdit";
import Senderid from "./pages/senderid/Senderid";
import SenderidCreate from "./pages/senderid/SenderidCreate";
import SenderidEdit from "./pages/senderid/SenderidEdit";
import PayoutSetting from "./pages/payoutSetting/PayoutSetting";
import PayoutSettingCreate from "./pages/payoutSetting/PayoutSettingCreate";
import PayoutSettingEdit from "./pages/payoutSetting/PayoutSettingEdit";
import ShortCodeMatches from "./pages/shortCodeMatches/ShortCodeMatches";
import ShortCodeMatchesCreate from "./pages/shortCodeMatches/ShortCodeMatchesCreate";
import ShortCodeMatchesEdit from "./pages/shortCodeMatches/ShortCodeMatchesEdit";
import MarketingPayouts from "./pages/marketingPayouts/MarketingPayouts";
import MarketingPayoutCreate from "./pages/marketingPayouts/MarketingPayoutCreate";
import MarketingPayoutEdit from "./pages/marketingPayouts/MarketingPayoutEdit";
import B2ctopup from "./pages/b2ctopup/B2ctopup";
import B2ctopupCreate from "./pages/b2ctopup/B2ctopupCreate";
import B2ctopupEdit from "./pages/b2ctopup/B2ctopupEdit";
import Rewardwallet from "./pages/rewardwallet/Rewardwallet";
import RewardwalletCreate from "./pages/rewardwallet/RewardwalletCreate";
import RewardwalletEdit from "./pages/rewardwallet/RewardwalletEdit";
import Rewardnomination from "./pages/rewardnomination/Rewardnomination";
import RewardnominationCreate from "./pages/rewardnomination/RewardnominationCreate";
import RewardnominationEdit from "./pages/rewardnomination/RewardnominationEdit";
import Reward from "./pages/rewardnomination/Reward";
import PlayPattern from "./pages/visuals/PlayPattern";
import Dailysummaryreport from "./pages/dailysummaryreport/Dailysummaryreport";
import DailysummaryreportCreate from "./pages/dailysummaryreport/DailysummaryreportCreate";
import DailysummaryreportEdit from "./pages/dailysummaryreport/DailysummaryreportEdit";
import Hourlystats from "./pages/hourlystats/Hourlystats";
import HourlystatCreate from "./pages/hourlystats/HourlystatCreate";
import HourlystatEdit from "./pages/hourlystats/HourlystatEdit";
import Dailyplayerreport from "./pages/dailyplayerreport/Dailyplayerreport";
import DailyplayerreportCreate from "./pages/dailyplayerreport/DailyplayerreportCreate";
import DailyplayerreportEdit from "./pages/dailyplayerreport/DailyplayerreportEdit";

function App() {
  return (
    <ErrorBoundary>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/otpConfirm" element={<OtpConfirm />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/topups" element={<Topups />} />
          <Route path="/topupCreate" element={<TopupCreate />} />
          <Route path="/play" element={<Play />} />
          <Route path="/playCreate" element={<PlayCreate />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/client" element={<Client />} />
          <Route path="/clientCreate" element={<ClientCreate />} />
          <Route path={`/client/:id/edit`} element={<ClientEdit />} />
          <Route path="/serviceType" element={<ServiceType />} />
          <Route path="/serviceTypeCreate" element={<ServiceTypeCreate />} />
          <Route path={`/serviceType/:id/edit`} element={<ServiceTypeEdit />} />
          <Route path="/sdpService" element={<SdpService />} />
          <Route path="/sdpServiceCreate" element={<SdpServiceCreate />} />
          <Route path={`/sdpService/:id/edit`} element={<SdpServiceEdit />} />
          <Route path="/appUsers" element={<AppUsers />} />
          <Route path="/dailyUsers" element={<DailyUsers />} />
          <Route path="/appUserCreate" element={<AppUserCreate />} />
          <Route path={`/appUser/:id/edit`} element={<AppUserEdit />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/depositCreate" element={<DepositCreate />} />
          <Route path={`/deposit/:id/edit`} element={<DepositEdit />} />
          <Route path="/winning" element={<Winning />} />
          <Route path="/winningCreate" element={<WinningCreate />} />
          <Route path={`/winning/:id/edit`} element={<WinningEdit />} />
          <Route path="/interactiveSms" element={<InteractiveSms />} />
          <Route path="/smsMessage" element={<SmsMessage />} />
          <Route path="/smsMessageCreate" element={<SmsMessageCreate />} />
          <Route path="/phonebook" element={<Phonebook />} />
          <Route path="/phonebookCreate" element={<PhonebookCreate />} />
          <Route path={`/phonebook/:id/edit`} element={<PhonebookEdit />} />
          <Route path="/phonebookupload" element={<Phonebookupload />} />
          <Route
            path="/phonebookuploadCreate"
            element={<PhonebookuploadCreate />}
          />
          <Route
            path={`/phonebookupload/:id/edit`}
            element={<PhonebookuploadEdit />}
          />
          <Route path="/bulkbroadcast" element={<Bulkbroadcast />} />
          <Route
            path="/bulkbroadcastCreate"
            element={<BulkbroadcastCreate />}
          />
          <Route
            path={`/bulkbroadcast/:id/edit`}
            element={<BulkbroadcastEdit />}
          />
          <Route path="/senderid" element={<Senderid />} />
          <Route path="/senderidCreate" element={<SenderidCreate />} />
          <Route path={`/senderid/:id/edit`} element={<SenderidEdit />} />
          <Route path="/payoutSetting" element={<PayoutSetting />} />
          <Route
            path="/payoutSettingCreate"
            element={<PayoutSettingCreate />}
          />
          <Route
            path={`/payoutSetting/:id/edit`}
            element={<PayoutSettingEdit />}
          />
          <Route path="/shortCodeMatches" element={<ShortCodeMatches />} />
          <Route
            path="/shortCodeMatchesCreate"
            element={<ShortCodeMatchesCreate />}
          />
          <Route
            path={`/shortCodeMatches/:id/edit`}
            element={<ShortCodeMatchesEdit />}
          />
          <Route path="/marketingPayouts" element={<MarketingPayouts />} />
          <Route
            path="/marketingPayoutCreate"
            element={<MarketingPayoutCreate />}
          />
          <Route
            path={`/marketingPayout/:id/edit`}
            element={<MarketingPayoutEdit />}
          />
          <Route path="/b2ctopup" element={<B2ctopup />} />
          <Route path="/b2ctopupCreate" element={<B2ctopupCreate />} />
          <Route path={`/b2ctopup/:id/edit`} element={<B2ctopupEdit />} />
          <Route path="/rewardwallet" element={<Rewardwallet />} />
          <Route path="/rewardwalletCreate" element={<RewardwalletCreate />} />
          <Route
            path={`/rewardwallet/:id/edit`}
            element={<RewardwalletEdit />}
          />
          <Route path="/rewardnomination" element={<Rewardnomination />} />
          <Route
            path="/rewardnominationCreate"
            element={<RewardnominationCreate />}
          />
          <Route
            path={`/rewardnomination/:id/edit`}
            element={<RewardnominationEdit />}
          />
          <Route path={`/reward/:id/edit`} element={<Reward />} />
          <Route path="/playPattern" element={<PlayPattern />} />
          <Route path="/dailysummaryreport" element={<Dailysummaryreport />} />
          <Route
            path="/dailysummaryreportCreate"
            element={<DailysummaryreportCreate />}
          />
          <Route
            path={`/dailysummaryreport/:id/edit`}
            element={<DailysummaryreportEdit />}
          />
          <Route path="/hourlystats" element={<Hourlystats />} />
          <Route path="/hourlystatCreate" element={<HourlystatCreate />} />
          <Route path={`/hourlystat/:id/edit`} element={<HourlystatEdit />} />
          <Route path="/dailyplayerreport" element={<Dailyplayerreport />} />
          <Route
            path="/dailyplayerreportCreate"
            element={<DailyplayerreportCreate />}
          />
          <Route
            path={`/dailyplayerreport/:id/edit`}
            element={<DailyplayerreportEdit />}
          />
        </Routes>
      </HashRouter>
    </ErrorBoundary>
  );
}
export default App;
